module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTIyNCA0ODBoNTc2YTMyIDMyIDAgMCAxIDAgNjRIMjI0YTMyIDMyIDAgMCAxIDAtNjR6IiBmaWxsPSIjMCIgcC1pZD0iNjk3Ij48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Subtract-outlined.svg
// module id = 3dPn
// module chunks = 74